import React, { useState } from "react";
import InputFactory from "../../../../components/InputFactory";
import { dialog } from "../../../../nq-component";
import DialogNote from "./DialogNote";

function DialogCreateTitle({
  schema,
  schemas,
  objects,
  onChangeData,
  handleSubmit,
  handleClose,
}) {
  const [invalidFields, setInvalidFields] = useState([]);

  function handleChange(value, field) {
    onChangeData(value, field);

    setInvalidFields((prev) =>
      prev.filter((invalidField) => invalidField !== field)
    );
  }

  function validateAndSubmit() {
    const requiredFields = [
      "positionTitle",
      "deploymentType",
      "qualificationStandard",
      "jobDescription",
    ];

    const missingFields = requiredFields.filter(
      (field) =>
        !objects?.[field] ||
        (typeof objects[field] === "string" && objects[field].trim() === "")
    );

    if (missingFields.length > 0) {
      setInvalidFields(missingFields);
      dialog.fire({
        html: <DialogNote missingFields={missingFields} />,
        footer: false,
      });
      return;
    }

    if (objects?.positionTitle?.includes("/")) {
      setInvalidFields((prev) => [...new Set([...prev, "positionTitle"])]);
      dialog.fire({
        html: (
          <DialogNote
            title="Invalid Character"
            message={`The character "/" is not allowed in the Position Title field.`}
          />
        ),
        footer: false,
      });
      return;
    }

    handleSubmit();
  }

  return (
    <>
      <div
        className="p-4 rounded"
        style={{ maxWidth: "450px", margin: "auto" }}
      >
        <div
          className="d-flex align-items-center mb-3"
          style={{ color: "#d18237" }}
        >
          <div
            className="bg-light p-3 rounded-circle d-flex justify-content-center align-items-center"
            style={{ width: "50px", height: "50px" }}
          >
            <i className="bi bi-plus-circle fs-4"></i>
          </div>
          <h5 className="fw-bold ms-2">
            {objects?.id ? "Edit Job Title" : "Create Job Title"}
          </h5>
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">
            Position Title<span className="text-danger fw-light ms-1">*</span>
          </label>
          <InputFactory
            type="String"
            field="positionTitle"
            onChange={(value, field) => handleChange(value, field)}
            placeholder="Enter position"
            required
            defaultValue={objects?.positionTitle}
            className={
              invalidFields.includes("positionTitle") ? "is-invalid" : ""
            }
          />
        </div>

        {/* <div className="mb-3">
          <label className="form-label fw-bold">
            Slot Vacancy<span className="text-danger fw-light ms-1">*</span>
          </label>
          <InputFactory
            type="Number"
            field="slotVacancy"
            onChange={(value, field) => handleChange(value, field)}
            placeholder="Enter slot"
            required
            defaultValue={objects?.slotVacancy}
            className={
              invalidFields.includes("slotVacancy") ? "is-invalid" : ""
            }
          />
        </div> */}

        <div className="mb-3">
          <label className="form-label fw-bold">
            Deployment Type<span className="text-danger fw-light ms-1">*</span>
          </label>
          <InputFactory
            type="Enum"
            field="deploymentType"
            options={["Deployed", "Direct Employee"]}
            onChange={(value, field) => handleChange(value, field)}
            placeholder="Select Deployment Type"
            required
            defaultValue={objects?.deploymentType}
            className={
              invalidFields.includes("deploymentType") ? "is-invalid" : ""
            }
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">
            Qualification Standard
            <span className="text-danger fw-light ms-1">*</span>
          </label>
          <InputFactory
            type="String"
            _type="Text"
            field="qualificationStandard"
            onChange={(value, field) => handleChange(value, field)}
            placeholder="Enter qualification standard"
            required
            defaultValue={objects?.qualificationStandard}
            className={
              invalidFields.includes("qualificationStandard")
                ? "is-invalid"
                : ""
            }
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">
            Job Description<span className="text-danger fw-light ms-1">*</span>
          </label>
          <InputFactory
            type="String"
            _type="Text"
            field="jobDescription"
            onChange={(value, field) => handleChange(value, field)}
            placeholder="Enter description"
            required
            defaultValue={objects?.jobDescription}
            className={
              invalidFields.includes("jobDescription") ? "is-invalid" : ""
            }
          />
        </div>

        {/* <div className="mb-3">
          <label className="form-label fw-bold">
            Location<span className="text-danger fw-light ms-1">*</span>
          </label>
          <InputFactory
            type="Relation"
            target="locations"
            schemas={schemas}
            field="locations"
            onChange={(value, field) => handleChange(value, field)}
            placeholder="Enter location"
            required
            defaultValue={objects?.locations}
            className={invalidFields.includes("locations") ? "is-invalid" : ""}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">
            Deadline<span className="text-danger fw-light ms-1">*</span>
          </label>
          <InputFactory
            type="Date"
            field="deadline"
            onChange={(value, field) => handleChange(value, field)}
            placeholder="Enter deadline"
            required
            defaultValue={
              objects?.deadline
                ? new Date(objects.deadline).toISOString().split("T")[0]
                : ""
            }
            className={invalidFields.includes("deadline") ? "is-invalid" : ""}
          />
        </div> */}

        <div className="d-flex justify-content-center">
          <button
            type="button"
            className="btn text-white px-4 me-2"
            style={{ backgroundColor: "#d18237" }}
            onClick={validateAndSubmit}
          >
            {objects?.id ? "Update" : "Confirm"}
          </button>
          <button
            className="btn px-4"
            onClick={() => handleClose()}
            style={{ backgroundColor: "#d0d0d0" }}
          >
            Cancel
          </button>
        </div>
      </div>
    </>
  );
}

export default DialogCreateTitle;
